import { render, staticRenderFns } from "./ChannelCard.vue?vue&type=template&id=0b82c0d4&"
import script from "./ChannelCard.vue?vue&type=script&setup=true&lang=js&"
export * from "./ChannelCard.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b82c0d4')) {
      api.createRecord('0b82c0d4', component.options)
    } else {
      api.reload('0b82c0d4', component.options)
    }
    module.hot.accept("./ChannelCard.vue?vue&type=template&id=0b82c0d4&", function () {
      api.rerender('0b82c0d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/onboardingShell/steps/channel/ChannelCard.vue"
export default component.exports